import { render } from "./BrokerAccountEditModalPopup.vue?vue&type=template&id=070e4e6e&scoped=true"
import script from "./BrokerAccountEditModalPopup.vue?vue&type=script&lang=js"
export * from "./BrokerAccountEditModalPopup.vue?vue&type=script&lang=js"

import "./BrokerAccountEditModalPopup.vue?vue&type=style&index=0&id=070e4e6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070e4e6e"]])

export default __exports__